(ns hai.users.form
  (:require
   [hai.users.helper :as users]
   [hai.ui.components.form.select.components :as select.components]
   [hai.ui.components.form.select.searchable-multi-select :as searchable-select]))

(defn user-search-emails-field
  [field]
  [searchable-select/field
   (assoc field
          :query [{:users/table [{:collection/items users/query}]}]
          :render {:style select.components/radix
                   :label users/->label}
          :transform-selected (fn [users]
                                (mapcat :user/email users))
          :placeholder "Full name or email...")])
